export const URL_SYNTHESIS_DOCUMENT = '/administration.settings.synthesis.documents';
export const SYNTHESIS_DOCUMENT_SECTION_NAME = 'app.administration.settings.synthesis.documents';
export const PAGE_SIZE = 10;
export const URL_DOCUMENT_TYPE = '/lookupValue/ACTIVE_DOCUMENT_TYPES';
export const URL_DOCUMENT_SOURCE_TYPE = '/valueLists/SYNTHESIS_DOCUMENTS_SOURCE';
